import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isNot',
})
export class IsNotPipe implements PipeTransform {
  transform(value: any, valueToCheck: any): boolean {
    if (value !== valueToCheck) return true;
    return false;
  }
}
